module.exports = __webpack_public_path__ + "img/table.0aba0789.jpg";